import { useNavigate } from 'react-router-dom';

import { usePickupDateTimeStore } from '@/stores/pickup-datetime-store';

interface HeaderProps {
  title: string;
}

export default function Header({ title }: HeaderProps) {
  const navigate = useNavigate();
  const { clearPickupDateTime } = usePickupDateTimeStore();

  const handleClose = () => {
    clearPickupDateTime();
    navigate('/', { replace: true });
  };

  return (
    <div className="flex justify-between items-center px-3 py-2.5 h-[50px]">
      <div className="w-[30px] h-[30px] flex items-center justify-center">
        <button onClick={handleClose} className="flex items-center justify-center">
          <img src="/icons/close.svg" alt="뒤로가기" width={30} height={30} />
        </button>
      </div>
      <h1 className="text-lg font-semibold text-[#1F1F1F]">{title}</h1>
      <div className="w-[30px] h-[30px]"></div>
    </div>
  );
}
